// extracted by mini-css-extract-plugin
export default {"headerCustom":"Header_headerCustom__uPZiL","heading":"Header_heading__Cfy8Z","fanduPoints":"Header_fanduPoints__zMGQq"};